import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="text-2xl font-bold">
              <span className="text-accent">BeeX</span>
              <span className="text-white"> Performance</span>
            </Link>
            <p className="text-muted-foreground text-sm">
              Egypt's premier dealer for SurRon electric bikes and high-performance parts. 
              Authorized retailer of Ultra Bee, Light Bee X, and Hyper Bee models.
            </p>
          </div>

          {/* Electric Bikes */}
          <nav aria-label="Electric Bikes">
            <h3 className="text-white font-semibold mb-4">Electric Bikes</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop SurRon Light Bee X (LBX) Electric Dirt Bike
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop SurRon Ultra Bee 21KW Electric Motorcycle
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop SurRon Hyper Bee Performance E-Bike
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Browse All CRF-Style Electric Dirt Bikes
                </Link>
              </li>
            </ul>
          </nav>

          {/* Parts & Upgrades */}
          <nav aria-label="Parts and Upgrades">
            <h3 className="text-white font-semibold mb-4">Parts & Upgrades</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop EBMX High-Performance Controllers
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop EBMX Racing Motors for SurRon
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop DHS Performance Lithium Batteries
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop Swingarms and Suspension Upgrades
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Shop Supermoto Wheel Conversion Kits
                </Link>
              </li>
            </ul>
          </nav>

          {/* Account & Support */}
          <nav aria-label="Account and Support">
            <h3 className="text-white font-semibold mb-4">Account</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/auth" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Login to Your BeeX Account or Create New Account
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  View Your Order History and Track Orders
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-muted-foreground hover:text-accent transition-colors inline-block min-h-[44px] py-2">
                  Browse All SurRon Products and Parts
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            &copy; 2025 BeeX Performance. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-muted-foreground">
            <span>Electric Bikes Egypt</span>
            <span>•</span>
            <span>SurRon Ultra Bee</span>
            <span>•</span>
            <span>Light Bee X L1E</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
